import React from 'react';
import { useTranslation } from 'react-i18next';
import { STRAPI_URL } from '../services/api';

const DEFAULT_OZELLIKLER = [
  {
    id: 'def1',
    title: 'Varlık Envanteri Yönetirmi',
    title_en: 'Asset Inventory Management',
    description:
      'Donanım, yazılım, veri, personel ve hizmetler dahil 9 varlık türünün kapsamlı takibi. Sınıflandırma seviyeleri ve sahiplik takibi ile tamamlanmıştır.',
    description_en:
      'Comprehensive tracking of 9 asset types including hardware, software, data, personnel, and services. Enhanced with classification levels and ownership tracking.',
    gorsel_placeholder: '/images/ozellikler/asset-inventory.png'
  },
  {
    id: 'def2',
    title: 'Risk Değerlendirme ve Tedavi',
    title_en: 'Risk Assessment and Treatment',
    description:
      'CIA üçlüsü ve olasılığa dayalı otomatik risk puanlaması. Görsel risk matrisi, tedavi planlaması ve yönetim onay iş akışları.',
    description_en:
      'Automated risk scoring based on the CIA triad and likelihood. Includes visual risk matrices, treatment planning, and management approval workflows.',
    gorsel_placeholder: '/images/ozellikler/risk-assessment.png'
  },
  {
    id: 'def3',
    title: 'Kontrol Yönetimi',
    title_en: 'Control Management',
    description:
      'Tüm 93 ISO 27001:2022 Ek A kontrolü önceden yüklenmiş. Uygulama durumunu takip edin, sahipleri atayın, risklere bağlayın ve kanıtları yönetin.',
    description_en:
      'All 93 ISO 27001:2022 Annex A controls are preloaded. Track implementation status, assign owners, link to risks, and manage evidence.',
    gorsel_placeholder: '/images/ozellikler/control-management.png'
  },
  {
    id: 'def4',
    title: 'Politika ve Prosedür Yönetimi',
    title_en: 'Policy and Procedure Management',
    description:
      'Versiyon kontrolü, gözden geçirme planlaması ve kontrol bağlantısı ile belge yönetimi. BGYS dokümantasyonunuzu düzenli ve güncel tutun.',
    description_en:
      'Manage your documentation with version control, review planning, and control linkage. Keep your ISMS documentation organized and up to date.',
    gorsel_placeholder: '/images/ozellikler/policy-management.png'
  },
  {
    id: 'def5',
    title: 'Denetim Yönetimi',
    title_en: 'Audit Management',
    description:
      'Yapılandırılmış kontrol listeleri ile iç denetimleri planlayın ve yürütün. Dış denetim bulgularını, düzeltici faaliyetleri ve belgelendirme durumunu takip edin.',
    description_en:
      'Plan and execute internal audits using structured control checklists. Track external audit findings, corrective actions, and documentation status.',
    gorsel_placeholder: '/images/ozellikler/audit-management.png'
  },
  {
    id: 'def6',
    title: 'Raporlama ve Analitik',
    title_en: 'Reporting and Analytics',
    description:
      'PDF, Excel ve CSV formatlarında kapsamlı raporlar oluşturun. Gösterge paneli analitiği güvenlik durumunuza gerçek zamanlı görünürlük sağlar.',
    description_en:
      'Generate comprehensive reports in PDF, Excel, and CSV formats. Dashboard analytics provide real-time visibility into your security posture.',
    gorsel_placeholder: '/images/ozellikler/reporting-analytics.png'
  }
];

const Ozellikler = ({ data }) => {
  const { i18n } = useTranslation();

  const lang = i18n.language === 'en' ? 'en' : 'tr';
  const tx = (tr, en) => (lang === 'en' ? (en || tr) : tr);

  const items = Array.isArray(data?.cards) && data.cards.length > 0
    ? data.cards
    : DEFAULT_OZELLIKLER;

  const resolveImage = (item) => {
    if (Array.isArray(item?.image) && item.image.length > 0) {
      return item.image[0];
    }

    if (Array.isArray(item?.gorsel) && item.gorsel.length > 0) {
      return item.gorsel[0];
    }

    if (item?.image?.url) return item.image;
    if (item?.gorsel?.url) return item.gorsel;

    return null;
  };

  const getImageUrl = (item) => {
    const media = resolveImage(item);

    if (media?.url) {
      return media.url.startsWith('http')
        ? media.url
        : `${STRAPI_URL}${media.url}`;
    }

    return item?.gorsel_placeholder || null;
  };

  return (
    <section className="px-6 md:px-20 xl:px-40 bg-white font-poppins">
      {items.map((item, index) => {
        const solda = index % 2 === 0;

        const baslik = tx(
          item.title || item.Title || item.baslik,
          item.title_en || item.Title_en || item.baslik_en
        );

        const aciklama = tx(
          item.description || item.Description || item.aciklama,
          item.description_en || item.Description_en || item.aciklama_en
        );

        const gorselUrl = getImageUrl(item);

        return (
          <div
            key={item.id || index}
            className={`flex flex-col md:flex-row items-center justify-between border-b border-gray-50 gap-10 md:gap-20 last:border-b-0 ${!solda ? 'md:flex-row-reverse' : ''
              }`}
          >
            <div className={`flex-1 max-w-[550px] ${!solda ? 'text-right' : 'text-left'}`}>
              <h2 className="text-3xl md:text-5xl font-semibold text-[#15614F] mb-6 leading-tight">
                {baslik}
              </h2>
              <p className="text-lg leading-relaxed text-[#4a6b63] opacity-90">
                {aciklama}
              </p>
            </div>

            <div className="flex-1 flex justify-center items-center">
              {gorselUrl && (
                <div className="w-full max-w-[350px] aspect-square flex items-center justify-center">
                  <img
                    src={gorselUrl}
                    alt={baslik}
                    className="w-80 h-80 md:w-[400px] md:h-[400px] object-contain transition-transform duration-500 hover:scale-105"
                    loading="lazy"
                  />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Ozellikler;